<template>
  <div class="h2h-logos">
    <TeamLogo v-if="!get(team, 'players.length')" :team="team" :selected="selected" :segment="segment" :size="size" />
    <div :class="{ 'club-logo': true, 'selected-team-logo': isSelected, logoSize:(segment ==='capture' || size === 'small')? true:false }"  v-for="(player, index) in get(team, 'players', [])" :key="index">
      <img width="60" :src="getLogo(player)"  class="img-object-contain"/>
    </div>
  </div>
</template>

<script>
import TeamLogo from './team-logo.vue';
import { toRefs, computed } from 'vue';
export default {
  components: { TeamLogo },
  props: ['team', 'selected', 'segment', 'size'],
  setup(props) {
    console.log({
      LogoProd: props
    });
    const { selected } = toRefs(props);
    const isSelected = selected ? computed(() => selected.value === true ) : false;
    return {
      get: _.get,
      isSelected,
    }
  },
  computed: {
    placeholder() {
      return process.env.VUE_APP_PLACEHOLDER || require('@/assets/images/club-placeholder.png');
    },
  },
  methods: {
    getLogo(player) {
      let teamLogo = this.get(player, 'meta.imgUrl', '');
      console.log('teamLogo', teamLogo);
      if (!teamLogo || teamLogo === '') {
        teamLogo = this.get(this.team, 'meta.imgUrl', '');
      }
      if (teamLogo && teamLogo !== '') {
        return teamLogo;
      }
      return this.placeholder;
    }
  }
};
</script>

<style scoped lang="scss">
.club-logo {
  width: 4.25rem;
  height: 4.25rem;
  /* border: 2px solid rgba(226, 9, 9, 0.1); */
  border-radius: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  padding: 5px;
  transition: all 0.1s ease-in-out;
}
.logoSize {
  width: 2.75rem;
  height: 2.75rem;
}
.selected-team-logo {
  border: 2px solid rgba($secondary, .5);
  transform: scale(1.05);
  animation: at-ripple 0.6s linear infinite;
}

.box {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 120%;
  height: 120%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.h2h-logos {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

</style>